import { useFilterUtilTransportLocationContext } from "./filter-util-transport-location.context";

export function FilterUtilTransportLocation() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterUtilTransportLocationContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}